import CompanyWrapper from 'src/company/templates/components/CompanyWrapper';
import ExportAssetsContent from './ExportAssetsContent';

export default function ExportAssetsTab() {
  return <CompanyWrapper contentComponent={ExportAssetsContent} />;
}
